import { Component, OnInit,Input ,Output,EventEmitter, ViewChild, ElementRef} from '@angular/core';
import { CommonapiService } from '../../../Service/Commonapi.service';
import { CustomerapiService } from '../../../Service/Customerapi.service';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { environment  } from 'src/environments/environment';
import { PlanAddService } from 'src/app/Module/Core/PlanAdd/PlanAdd.service';
import { MatDatepicker } from "@angular/material/datepicker";
import { Common } from '../../../Utility/Common';

@Component({
  selector: 'app-CTPlanCalendar',
  templateUrl: './CTPlanCalendar.component.html'
})
export class CTPlanCalendarComponent implements OnInit {
  @Output() CallParent: EventEmitter<any> = new EventEmitter();
  @Input() data: any;@Input() state: any;
  //maxDate: Date = new Date();
  currdate = new Date();
  fiveDaysAgo = new Date(new Date().setDate(new Date().getDate() - 3));
  maxDate = new Date(new Date().setDate(new Date().getDate() + 3));
  showaddplancalendar=false;
  @ViewChild('picker') picker:any;

  constructor(private Winfoapi: CommonapiService, private custapi: CustomerapiService,private router: Router, private planAddapi: PlanAddService)
   { 

   }  
  
  // this.state: any = {
  //   meetingdate: { value: "", iserr: false, err_txt: "" },    
  // }

  ngOnInit() {
    //this.Show(customerid:any,customername);
    this.Show(this.state)
  }
  
  Show(state)
  {this.state=state;
    console.log('this.state', this.state);
    
    //alert(customerid + customername);
    const meetingDefaultDate: Date = new Date();
    const format1 = "YYYY-MM-DD HH:mm:ss";
    this.state.meetingdate.value = moment(meetingDefaultDate).format(format1)
    this.showaddplancalendar = true;
    setTimeout(() => {
      this.Callopen_cal(this.picker);  
    });    
  }
  
  AddPlanclosed(){    
    this.showaddplancalendar = false;
    //alert('close');      
  }

  AddPlanCancelled()
  {
    this.showaddplancalendar = false;    
  }

  AddPlanApply()
  { 
    //alert('apply');      
    this.showaddplancalendar = false;
    this.AddPlanCalendar();
  }
 
  Callparentfunc(status,data=''){
    this.CallParent.emit({status:status,data:data});
  }

  AddPlanCalendar()
  {   
    //alert(this.state.meetingdate.value);
    
   const format1 = "YYYY-MM-DD  HH:mm:ss";
   let selectedDate = moment(this.state.meetingdate.value).format(format1);
   
   //let selectedDate = '2024-09-10' // need to remove this and add above one

   const format2 = "DD MMMM YYYY";
   let FormattedCalenderDate =  moment(this.state.meetingdate.value).format(format2);

    var postdata = {

      "planId" :  "",    
      "calendarDate" :  selectedDate,
      "customerId" :  this.state.customerid.value,
      "planStatus" :  "",
      "statusChangedDate" :  "",
      "movedToDate" :  "",
      "statusReasonId" :  "",
      "statusReason" :  "",
      "planAlongStatus" :  "",
      "planAlongStatusSub" :  "",
      "reasonId" :  "",
      "reason" :  "",
      "title" :  "create category meeting on " + FormattedCalenderDate,
      "data" :  "",
      "isRead" :  "",
      "url" :  environment.angularurl+"#/user/planlist",
    }
  
    console.log("postdata",postdata);
    
    //return false;
  
    this.Winfoapi.loader.startLoading();
    this.planAddapi.AddPlan(postdata, false).then(data => {
  
      if (data && data!= undefined && data != '[]') {
  
        if(data.plan_id > 0)
        {
          this.Winfoapi.Toast_success(" \""+ this.state.customername.value +  "\" is Added  ",true);          
        }   
  
      }
      this.showaddplancalendar = false;
      this.Winfoapi.loader.stopLoading();
    })

  }
  
  //popup close button
  AddPlanCalendar_cancel() {    
    this.showaddplancalendar = false;
    this.Callparentfunc(0);
  }

  //open the calendar control
  Callopen_cal(pic) {
    setTimeout(() => { pic.open() }, 100);
  }
 
  onOpen() {
    //Common._$(".mat-datepicker-close-button .mdc-button__label").text('Close');
    Common._$(".mat-datepicker-close-button").hide();
  }

}


